export const borderRadii = {
  l: "32px",
  m: "24px",
  s: "16px",
  xs: "8px",
} as const
